import { WhatsappShareButton } from 'react-share'

export default function WhatsAppShare({
  url,
  shortDescription,
  children,
}: {
  url: string
  shortDescription: string
  children: React.ReactNode
}): JSX.Element {
  return (
    <WhatsappShareButton
      className="share-icon"
      url={url}
      title={shortDescription}
      separator=" "
      style={{ width: '100%' }}
    >
      {children}
    </WhatsappShareButton>
  )
}
